module.exports = __webpack_public_path__ + "5d0933280a070d798bb26ff90fe562fb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-112.svg
// module id = 556
// module chunks = 0